import React from 'react';
import TagAvatar from './TagAvatar';
import { Tooltip } from 'react-tooltip';

const TagList = ({ tags = [] }) => {
    if (!tags || tags.length === 0) return null;

    // Logic: Show first 2 tags, then +N
    const displayTags = tags.slice(0, 2);
    const remainingCount = tags.length - 2;
    const remainingTags = tags.slice(2);

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {displayTags.map((tag, index) => (
                <TagAvatar key={tag.id || index} tag={tag} />
            ))}

            {remainingCount > 0 && (
                <>
                    <div
                        data-tooltip-id={`more-tags-tooltip-${tags[0].id}`} // unique enough base
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            backgroundColor: '#e0e0e0',
                            color: '#333',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            cursor: 'default',
                            flexShrink: 0
                        }}
                    >
                        +{remainingCount}
                    </div>
                    <Tooltip
                        id={`more-tags-tooltip-${tags[0].id}`}
                        place="top"
                        style={{ zIndex: 9999 }}
                        clickable
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            {remainingTags.map(tag => (
                                <div key={tag.id} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: tag.color }}></div>
                                    <span>{tag.name}</span>
                                </div>
                            ))}
                        </div>
                    </Tooltip>
                </>
            )}
        </div>
    );
};

export default TagList;
